import { RefreshCw } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";

interface RefreshCountdownProps {
  dataUpdatedAt: number | undefined;
  intervalMs: number;
  isFetching?: boolean;
  className?: string;
}

export function RefreshCountdown({
  dataUpdatedAt,
  intervalMs,
  isFetching = false,
  className = "",
}: RefreshCountdownProps) {
  const seconds = useCountdown(dataUpdatedAt, intervalMs);

  return (
    <span className={`flex items-center gap-1.5 text-xs text-slate-500 ${className}`}>
      <RefreshCw className={`h-3 w-3 ${isFetching ? "animate-spin" : ""}`} />
      {isFetching ? "Updating..." : `Next update in ${seconds}s`}
    </span>
  );
}
